import api from './api';

export interface CreateShipmentRequest {
  warehouse_name: 'NOIDA' | 'NIMIYA';
  weight?: number;
  length?: number;
  width?: number;
  height?: number;
}

export interface CreateShiprocketShipmentRequest {
  pickup_location?: string;
  courier_id?: string;
  weight?: number;
  length?: number;
  width?: number;
  height?: number;
}

export interface CreateShipmentResponse {
  success: boolean;
  message: string;
  order_id: string;
  order_number: string;
  awb_number: string;
  tracking_url?: string;
  label_url?: string;
  carrier: string;
  courier_name?: string;
  shipment_id?: string | number;
  status?: string;
  shipment_details?: any;
}

export interface TrackShipmentResponse {
  success: boolean;
  order_id: string;
  order_number: string;
  awb_number: string;
  tracking_url: string;
  shipment_status?: string;
  tracking_info: any;
}

export interface ShipmentLabelResponse {
  success: boolean;
  order_id: string;
  order_number: string;
  awb_number: string;
  label_url: string;
}

export const shipmentService = {
  /**
   * Create Delhivery shipment for a sales order
   */
  createShipment: async (orderId: string, data: CreateShipmentRequest): Promise<CreateShipmentResponse> => {
    const params = new URLSearchParams();
    params.append('warehouse_name', data.warehouse_name);
    if (data.weight !== undefined) params.append('weight', data.weight.toString());
    if (data.length !== undefined) params.append('length', data.length.toString());
    if (data.width !== undefined) params.append('width', data.width.toString());
    if (data.height !== undefined) params.append('height', data.height.toString());
    
    const response = await api.post(`/admin/shipments/sales-order/${orderId}/create?${params.toString()}`);
    return response.data;
  },

  /**
   * Create Shiprocket shipment for a sales order
   */
  createShiprocketShipment: async (orderId: string, data: CreateShiprocketShipmentRequest): Promise<CreateShipmentResponse> => {
    const params = new URLSearchParams();
    if (data.pickup_location) params.append('pickup_location', data.pickup_location);
    if (data.courier_id) params.append('courier_id', data.courier_id);
    if (data.weight !== undefined) params.append('weight', data.weight.toString());
    if (data.length !== undefined) params.append('length', data.length.toString());
    if (data.width !== undefined) params.append('width', data.width.toString());
    if (data.height !== undefined) params.append('height', data.height.toString());

    const response = await api.post(`/admin/shipments/sales-order/${orderId}/create-shiprocket?${params.toString()}`);
    return response.data;
  },

  /**
   * Track shipment for a sales order
   */
  trackShipment: async (orderId: string): Promise<TrackShipmentResponse> => {
    const response = await api.get(`/admin/shipments/sales-order/${orderId}/track`);
    return response.data;
  },

  /**
   * Get shipping label URL for a sales order
   */
  getShipmentLabel: async (orderId: string): Promise<ShipmentLabelResponse> => {
    const response = await api.get(`/admin/shipments/sales-order/${orderId}/label`);
    return response.data;
  },

  /**
   * Track ANY shipment by AWB number (direct package / external booking)
   */
  trackAnyAWB: async (awbNumber: string, carrier = 'delhivery'): Promise<any> => {
    const params = new URLSearchParams();
    params.append('awb_number', awbNumber);
    params.append('carrier', carrier);
    const response = await api.get(`/admin/shipments/track-awb?${params.toString()}`);
    return response.data;
  },
};



